import { initFollowerMulti } from './vestfirma-pdp-follower-multi.js';

function formatMoney(cents, moneyFormat) {
  const value = Number(cents);
  if (!Number.isFinite(value)) return '';
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(value, moneyFormat || '${{amount}}');
  }
  return `R$ ${(value / 100).toFixed(2).replace('.', ',')}`;
}

function createFollowerPdpAdapter(root) {
  return {
    root,
    updatePrices(variant) {
      const price = variant?.price != null ? Number(variant.price) : 0;
      if (!Number.isFinite(price) || price <= 0) return;

      const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
      const hero = root.querySelector('[data-md-price-hero]');
      if (hero) hero.textContent = formatMoney(price, moneyFormat);

      const inst = root.querySelector('[data-md-installments]');
      if (inst) {
        const count = Number(root.dataset.installments || 12);
        const instVal = Math.round(price / count);
        const tpl = inst.dataset.template || '';
        inst.textContent = tpl
          .replace('__COUNT__', String(count))
          .replace('__PRICE__', formatMoney(instVal, moneyFormat));
      }
    },
  };
}

function syncFollowerPriceFromStamp(root) {
  const checked =
    root.querySelector('.vestfirma-pdp-variant-option--estampa input[type="radio"]:checked') ||
    root.querySelector('.vestfirma-pdp-variant-option--estampa input[type="radio"]');
  const adapter = createFollowerPdpAdapter(root);

  if (checked instanceof HTMLInputElement && checked.dataset.variantPrice) {
    const price = Number(checked.dataset.variantPrice);
    if (Number.isFinite(price) && price > 0) {
      adapter.updatePrices({ price });
      return;
    }
  }

  const initialPrice = Number(root.dataset.variantPrice || 0);
  if (initialPrice > 0) adapter.updatePrices({ price: initialPrice });
}

function bindFollowerVariantGuard(root) {
  if (root.dataset.vfFollowerGuardBound === 'true') return;
  root.dataset.vfFollowerGuardBound = 'true';

  root.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;
      if (!target.closest('.vestfirma-pdp-variant-option--estampa')) return;

      event.stopImmediatePropagation();

      const picker = target.closest('variant-picker');
      if (picker && typeof picker.updateSelectedOption === 'function') {
        picker.updateSelectedOption(target);
      }

      syncFollowerRetail(root, true);
      syncFollowerPriceFromStamp(root);
      if (root._vfFollowerMulti?.updateCommerce) {
        root._vfFollowerMulti.updateCommerce();
      }
    },
    true
  );

  root.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('.vestfirma-pdp-variant-option--estampa')) return;

      window.setTimeout(() => {
        syncFollowerRetail(root, true);
        syncFollowerPriceFromStamp(root);
        root._vfFollowerMulti?.updateCommerce?.();
      }, 0);
    },
    true
  );
}

function ensureFollowerMulti(root) {
  if (root._vestfirmaPdp?.ensureFollowerMulti) {
    root._vestfirmaPdp.ensureFollowerMulti();
    return;
  }

  const grid = root.querySelector('[data-vf-follower-size-grid]');
  if (!grid) return;

  if (root._vfFollowerMulti && root._vfFollowerMulti.grid === grid) {
    root._vfFollowerMulti.refresh({ forceGrid: true });
    return;
  }

  const pdp = root._vestfirmaPdp || createFollowerPdpAdapter(root);
  const controller = initFollowerMulti(pdp);
  if (!controller) return;

  root._vfFollowerMulti = controller;
  if (root._vestfirmaPdp) root._vestfirmaPdp.followerMulti = controller;
  syncFollowerPriceFromStamp(root);
}

function syncFollowerRetail(root, forceGrid) {
  bindFollowerVariantGuard(root);
  ensureFollowerMulti(root);

  if (root._vestfirmaPdp?.syncFollowerVariant) {
    root._vestfirmaPdp.syncFollowerVariant();
    return;
  }

  if (root._vfFollowerMulti) {
    root._vfFollowerMulti.refresh({ forceGrid: !!forceGrid });
  } else {
    syncFollowerPriceFromStamp(root);
  }

  if (window.VestfirmaPdpStickyGallery?.updateForRoot) {
    window.VestfirmaPdpStickyGallery.updateForRoot(root);
  }
}

function initFollowerRetail(root) {
  if (!root || root.dataset.pdpFollowerRetail !== 'true') return;
  if (root.dataset.vfFollowerBootModule === 'true') return;
  root.dataset.vfFollowerBootModule = 'true';

  syncFollowerRetail(root, true);
  [120, 400, 900].forEach((ms) => {
    window.setTimeout(() => syncFollowerRetail(root, true), ms);
  });
}

function boot() {
  document.querySelectorAll('[data-md-pdp][data-pdp-follower-retail="true"]').forEach((root) => {
    if (root instanceof HTMLElement) initFollowerRetail(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target?.querySelector?.('[data-md-pdp][data-pdp-follower-retail="true"]');
  if (root instanceof HTMLElement) {
    delete root.dataset.vfFollowerBootModule;
    initFollowerRetail(root);
  }
});

document.addEventListener('variant:update', (event) => {
  const productId = event.detail?.data?.productId;
  document.querySelectorAll('[data-md-pdp][data-pdp-follower-retail="true"]').forEach((root) => {
    if (productId && String(productId) !== String(root.dataset.productId)) return;
    syncFollowerRetail(root, true);
  });
});
